<div
  class="trustpilot-widget"
  id="trustbox"
  data-locale="en-US"
  data-template-id="53aa8807dec7e10d38f59f32"
  data-businessunit-id="55428aa00000ff00057f1e88"
  data-style-margin="0"
  data-theme="dark"
  data-style-height="auto"
  data-style-width="62%"
  data-text-color="#F0F3F5"
>
  <a
    href="https://www.trustpilot.com/review/www.bestegg.com"
    target="_blank"
    rel="noopener"
    >Trustpilot</a
  >
</div>
